import { Component, OnInit } from "@angular/core";
import { AppService } from "../app.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from "crypto-js";
import { Router } from "@angular/router";

import { environment } from "src/environments/environment";
declare const grecaptcha: any;
@Component({
  selector: "app-contactus",
  templateUrl: "./contactus.component.html",
  styleUrls: ["./contactus.component.css"],
})
export class ContactusComponent implements OnInit {
  userInfo: any;
  model: any = {};
  myRecaptcha: boolean;
  cMessage: any = "";
  isActive: boolean;
  constructor(
    private changeService: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private route: Router
  ) {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem(environment.localStorageKey),
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );

      this.model.name = this.userInfo.name;
      this.model.mobile = this.userInfo.mobile_number;
      this.model.email = this.userInfo.email;
    }
  }

  ngOnInit(): void {
    this.isActive = true;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }
  /**
   * This function is use for submit contact us form
   * @param form
   */
  contactUsForm(form) {
    const recaptcha_response = grecaptcha.getResponse();
    this.model.rtoken = recaptcha_response;
    if (this.model && form) {
      this.spinner.show();
      this.changeService.contactUs(this.model).subscribe(
        (res) => {
          if (res) {
            this.spinner.hide();
            this.toastr.success(res.message, "Success!", {
              closeButton: true,
            });
            grecaptcha.reset();
            form.resetForm();
            this.model = {};
            if (localStorage.getItem(environment.localStorageKey)) {
              this.route.navigate(["/home"]);
            }
          }
        },
        (err) => {
          if (err) {
            this.toastr.error("Invalid credentials", "OOPS!", {
              closeButton: true,
            });
            this.spinner.hide();
          }
        }
      );
    }
  }
  onScriptLoad() {}

  onScriptError() {
    this.cMessage = "Captcha is required";
  }

  remove() {
    this.isActive = false;
  }
}
